import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize32 {
  size: '32';
}
interface OverrideIconSize40 {
  size: '40';
}
type OverrideIconSize = OverrideIconSize32 | OverrideIconSize40;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '32') {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3012 17.8303C10.3012 18.1139 10.5427 18.3446 10.8397 18.3446C11.1366 18.3446 11.3781 18.1139 11.3781 17.8303V14.6314H12.2183C12.5096 14.6314 12.7467 14.3948 12.7467 14.1042C12.7467 13.8135 12.5097 13.577 12.2183 13.577H9.46107C9.16975 13.577 8.93262 13.8135 8.93262 14.1042C8.93262 14.3948 9.16963 14.6314 9.46107 14.6314H10.3012V17.8303Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1132 18.0998C15.165 18.2464 15.3368 18.3376 15.5613 18.3376C15.6794 18.3377 15.7961 18.3123 15.9036 18.2633C16.052 18.1951 16.1947 18.0067 16.0308 17.4977L14.7434 14.109C14.6524 13.8506 14.3768 13.5849 14.0251 13.577C13.6744 13.585 13.3988 13.8506 13.3081 14.1085L12.0201 17.4986C11.8566 18.0065 11.9993 18.1948 12.1477 18.2633C12.2551 18.3123 12.3719 18.3377 12.49 18.3376C12.7146 18.3376 12.8862 18.2465 12.9378 18.1001L13.2046 17.4016L14.8466 17.4017L15.1132 18.0998ZM14.0256 14.9201L14.5634 16.4479H13.4878L14.0256 14.9201Z"
          fill={color}
        />
        <path
          d="M16.3814 17.7725C16.3814 18.0446 16.6128 18.2661 16.8974 18.2661H18.6249C18.9095 18.2661 19.141 18.0446 19.141 17.7725C19.141 17.5003 18.9095 17.2788 18.6249 17.2788H17.4807V14.1154C17.4807 13.8184 17.2341 13.577 16.9311 13.577C16.628 13.577 16.3814 13.8184 16.3814 14.1154V17.7725Z"
          fill={color}
        />
        <path
          d="M19.3504 17.7991C19.3504 18.0961 19.5919 18.3376 19.8889 18.3376C20.0317 18.3374 20.1686 18.2805 20.2696 18.1796C20.3706 18.0786 20.4274 17.9417 20.4276 17.7988V16.624L20.6144 16.4372L21.8771 18.1103C21.9272 18.1771 21.9921 18.2313 22.0668 18.2685C22.1415 18.3056 22.2239 18.3248 22.3073 18.3244C22.4242 18.3246 22.5381 18.2865 22.6312 18.2157C22.6878 18.1733 22.7354 18.1201 22.7712 18.0591C22.8071 17.9981 22.8305 17.9307 22.8401 17.8606C22.8501 17.7905 22.8462 17.7193 22.8284 17.6508C22.8107 17.5823 22.7795 17.518 22.7367 17.4617L21.4113 15.7058L22.6384 14.4788C22.7227 14.3944 22.765 14.278 22.7572 14.151C22.7495 14.0251 22.6932 13.9039 22.5989 13.8096C22.4977 13.7086 22.3628 13.6506 22.2283 13.6506C22.1131 13.6506 22.0069 13.6932 21.9296 13.7704L20.4273 15.2728V14.1154C20.4273 13.8184 20.1858 13.577 19.8889 13.577C19.5919 13.577 19.3504 13.8184 19.3504 14.1154V17.7991Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 16C2 8.26803 8.26803 2 16 2C23.732 2 30 8.26803 30 16C30 23.732 23.732 30 16 30C8.26803 30 2 23.732 2 16ZM16 8.41667C10.8453 8.41667 6.66667 11.7115 6.66667 15.7757C6.66667 18.4032 8.41363 20.7088 11.0415 22.0108C10.8985 22.5038 10.1228 25.1827 10.0919 25.3931C10.0919 25.3931 10.0733 25.5512 10.1757 25.6115C10.2781 25.6718 10.3985 25.625 10.3985 25.625C10.6922 25.584 13.8037 23.3984 14.3423 23.0188C14.8803 23.095 15.4343 23.1346 16 23.1346C21.1547 23.1346 25.3333 19.84 25.3333 15.7757C25.3333 11.7115 21.1547 8.41667 16 8.41667Z"
          fill={color}
        />
      </svg>
    );
  }
  if (size === '40') {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.8765 22.2879C12.8765 22.6424 13.1784 22.9307 13.5496 22.9307C13.9208 22.9307 14.2227 22.6424 14.2227 22.2879V18.2893H15.2729C15.637 18.2893 15.9334 17.9936 15.9334 17.6302C15.9334 17.2669 15.6372 16.9712 15.2729 16.9712H11.8263C11.4622 16.9712 11.1658 17.2669 11.1658 17.6302C11.1658 17.9936 11.462 18.2893 11.8263 18.2893H12.8765V22.2879Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8914 22.6247C18.9561 22.808 19.1709 22.922 19.4515 22.922C19.5992 22.9221 19.7451 22.8904 19.8794 22.8292C20.0649 22.7439 20.2432 22.5083 20.0384 21.8721L18.4291 17.6363C18.3155 17.3133 17.9709 16.9812 17.5313 16.9713C17.0929 16.9813 16.7484 17.3133 16.635 17.6356L15.025 21.8733C14.8206 22.5081 14.999 22.7435 15.1846 22.8291C15.3188 22.8904 15.4648 22.9221 15.6124 22.922C15.8931 22.922 16.1077 22.8081 16.1722 22.6251L16.5057 21.752L18.5581 21.7522L18.8914 22.6247ZM17.532 18.6501L18.2043 20.5599H16.8597L17.532 18.6501Z"
          fill={color}
        />
        <path
          d="M20.4767 22.2156C20.4767 22.5557 20.7659 22.8326 21.1217 22.8326H23.2811C23.6368 22.8326 23.9262 22.5557 23.9262 22.2156C23.9262 21.8754 23.6368 21.5986 23.2811 21.5986H21.8509V17.6443C21.8509 17.2731 21.5426 16.9712 21.1638 16.9712C20.7849 16.9712 20.4767 17.2731 20.4767 17.6443V22.2156Z"
          fill={color}
        />
        <path
          d="M24.1881 22.2489C24.1881 22.6201 24.49 22.922 24.8612 22.922C25.0397 22.9217 25.2108 22.8507 25.337 22.7245C25.4632 22.5982 25.5343 22.4271 25.5345 22.2485V20.78L25.768 20.5464L27.3465 22.6379C27.409 22.7214 27.4902 22.7891 27.5836 22.8356C27.6769 22.882 27.7799 22.9059 27.8842 22.9055C28.0304 22.9058 28.1726 22.8581 28.2891 22.7696C28.3598 22.7166 28.4193 22.6501 28.4641 22.5739C28.5089 22.4977 28.5381 22.4133 28.5502 22.3258C28.5627 22.2382 28.5578 22.1491 28.5356 22.0635C28.5134 21.9779 28.4744 21.8975 28.421 21.8271L26.7642 19.6322L28.298 18.0986C28.4035 17.993 28.4563 17.8475 28.4465 17.6888C28.4369 17.5314 28.3666 17.3799 28.2487 17.2621C28.1222 17.1358 27.9535 17.0633 27.7854 17.0633C27.6414 17.0633 27.5087 17.1164 27.4121 17.2131L25.5342 19.0909V17.6443C25.5342 17.2731 25.2323 16.9712 24.8612 16.9712C24.49 16.9712 24.1881 17.2731 24.1881 17.6443V22.2489Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 20C2.5 10.335 10.335 2.5 20 2.5C29.665 2.5 37.5 10.335 37.5 20C37.5 29.665 29.665 37.5 20 37.5C10.335 37.5 2.5 29.665 2.5 20ZM19.9999 10.5208C13.5566 10.5208 8.33328 14.6393 8.33328 19.7196C8.33328 23.004 10.517 25.886 13.8018 27.5135C13.6231 28.1298 12.6534 31.4783 12.6148 31.7414C12.6148 31.7414 12.5916 31.939 12.7196 32.0144C12.8476 32.0898 12.9981 32.0312 12.9981 32.0312C13.3652 31.98 17.2546 29.2479 17.9278 28.7735C18.6003 28.8688 19.2928 28.9183 19.9999 28.9183C26.4433 28.9183 31.6666 24.8 31.6666 19.7196C31.6666 14.6393 26.4433 10.5208 19.9999 10.5208Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 32, 40 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'kakao');
export default IconComponent;
